"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _index = require("./index");
var _index2 = _interopRequireDefault(require("../../../../components/ActivationCode/index.vue"));
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _loop = require("@/api/loop");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vuex = require("vuex");
var _releaseNote = require("@/log/release-note");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const POPUP_MESSAGE_MAX_LENGTH = 600;
// While testing with character limit in the input box (textarea), it always occupies 7 characters. Therefore, we add this buffer.
const INPUT_BOX_LENGTH_BUFFER = 7;
const PROGRAM_DESCRIPTION_MAX_LENGTH = 140;
var _default = exports.default = {
  name: "LoopMain",
  components: {
    LoopGeninfo: _index.LoopGeninfo,
    LoopProgram: _index.LoopProgram,
    LoopParticipant: _index.LoopParticipant,
    LoopStaff: _index.LoopStaff,
    LoopCode: _index.LoopCode,
    ActivationCode: _index2.default,
    LoopEmailSetting: _index.LoopEmailSetting
  },
  props: {
    displayType: {
      type: String,
      default: "create"
    }
  },
  data() {
    return {
      fullscreenloading: false,
      recordStatus: "",
      flagRemindSave: false,
      loopForm: {
        id: "",
        title: "",
        publish: "",
        type: "",
        color: "",
        start: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        end: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        locale: "",
        description: "",
        programs: [],
        staff: [],
        welcomeBox: {
          //coachUuid: "",
          //coachUgivenName: "",
          coachHtmlTips: "",
          resource: "",
          resourceTitle: ""
        },
        internal: {
          title: "",
          opportunityNumber: "",
          clientName: "",
          remark: ""
        },
        pid: "",
        metadata: {
          tenant: ""
        },
        modifiedBy: "",
        createdAt: "",
        updatedAt: "",
        automatedEmail: []
      },
      selectShowButton: [],
      oldClientPocList: []
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(["email"])
  },
  created() {
    if (this.displayType === "edit") {
      const id = typeof this.$route.params.id === "undefined" ? this.loopForm.id : this.$route.params.id;
      this.recordStatus = "edit";
      this.fromId = typeof this.$route.query.fromId === "undefined" ? "" : this.$route.query.fromId;
      this.getLoop(id, false); // copy mode is false
    } else if (this.displayType === "createfromcopy") {
      this.fromId = typeof this.$route.query.fromId === "undefined" ? "" : this.$route.query.fromId;
      this.getLoop(this.fromId, true);
    } else {
      // create from new
      this.recordStatus = "create";
    }
  },
  methods: {
    async doCreate(publishStatus) {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const oEmail = (0, _cookie.getCookie)("EMAIL");
      this.loopForm.publish = publishStatus;

      // validate
      if (this.loopForm.metadata.tenant === "") {
        this.fullscreenloading = false;
        const msg = "Please select the tenant";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.type === "") {
        this.fullscreenloading = false;
        const msg = "Loop's type is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.title === "") {
        this.fullscreenloading = false;
        const msg = "Loop's Title is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.start.utc === "" || this.loopForm.end.utc === "") {
        this.fullscreenloading = false;
        const msg = "Loop's event time is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      const startDate = new Date(this.loopForm.start.utc);
      const endDate = new Date(this.loopForm.end.utc);
      if (startDate > endDate) {
        this.fullscreenloading = false;
        const msg = "Start-Time is later than End-Time in Loop event time";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.start.timezone === "" || this.loopForm.end.timezone === "") {
        this.fullscreenloading = false;
        const msg = "Timezone is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.welcomeBox.coachHtmlTips === "") {
        this.fullscreenloading = false;
        const msg = "Loop's Welcome Message is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      var programLength = typeof this.loopForm.programs === "undefined" ? 0 : this.loopForm.programs.length;
      if (programLength > 0) {
        for (let stageIndex in this.loopForm.programs) {
          if ((this.loopForm.programs[stageIndex].start.utc === "" || this.loopForm.programs[stageIndex].end.utc === "") && this.loopForm.publish !== "draft") {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Event time is missing in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          const startDate = new Date(this.loopForm.programs[stageIndex].start.utc);
          const endDate = new Date(this.loopForm.programs[stageIndex].end.utc);
          if (startDate > endDate && this.hikeForm.publish !== "draft") {
            this.fullscreenloading = false;
            const msg = `Start-Time is later than End-Time in Program ` + (1 * stageIndex + 1) + " event time";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
        }
      }

      // Reset Id to '' if copy
      // if (this.loopForm.id === "copy") {
      //   this.loopForm.id = "";
      // }

      // submit
      if (this.loopForm.id === "" || this.loopForm.id === "copy") {
        let data = _lodash.default.cloneDeep(this.loopForm);

        // LHVO-4155 Do not pass resource if it is empty
        if (data.welcomeBox.resource === "") {
          delete data.welcomeBox.resource;
        }
        data.programs.forEach((program, index) => {
          if (program.options.length > 0) {
            program.options.forEach((item, index) => {
              if (item.objectId === "" || item.objectId === undefined || item.objectId === null) {
                program.options.splice(index, 1);
              }
            });
          }
        });
        data.id = "";
        delete data.createdAt;
        delete data.updatedAt;
        console.info(data);
        (0, _loop.createLoop)(token, data).then(response => {
          (0, _log.showDebugLog)("Loop-create-response1", response);
          this.fullscreenloading = false;
          this.loopForm.id = response.data.id;
          this.loopForm.publish = response.data.publish;

          // console.log('Success create', this.displayType)
          const msg = `${response.data.title} (${response.data.id}) is created.`;
          (0, _log.displayPopupMessage)(msg, "success");

          // this.isCreatedRecord = true

          (0, _ga.writeGaEvent)(this, "Loop", `${_lifehikesInitData.userEvent.loop.create}`, oEmail, `Loop Id: ${this.loopForm.id}`);
          var keys_to_keep = ["role", "user"];
          const result = this.loopForm.staff.map(e => {
            const obj = {};
            keys_to_keep.forEach(k => obj[k] = e[k]);
            return obj;
          });
          (0, _ga.writeGaEvent)(this, "Loop", `${_lifehikesInitData.userEvent.loop.create}`, oEmail, `Staff: ${JSON.stringify(result)}`);
          if (this.displayType === "createfromcopy" || this.displayType === "create") {
            this.$router.push(`/loop/edit/${response.data.id}`);
          }
        }).catch(error => {
          (0, _log.showDebugLog)("loop-create-error", error);
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)(error, "error");
        });
      }
    },
    async doSave(publishStatus) {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const oEmail = (0, _cookie.getCookie)("EMAIL");
      const id = typeof this.$route.params.id === "undefined" ? this.loopForm.id : this.$route.params.id;
      this.loopForm.publish = publishStatus;

      // validate
      if (this.loopForm.metadata.tenant === "") {
        this.fullscreenloading = false;
        const msg = "Please select the tenant";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.type === "") {
        this.fullscreenloading = false;
        const msg = "Loop's type is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.title === "") {
        this.fullscreenloading = false;
        const msg = "Loop's Title is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.start.utc === "" || this.loopForm.end.utc === "") {
        this.fullscreenloading = false;
        const msg = "Loop's event time is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      const startDate = new Date(this.loopForm.start.utc);
      const endDate = new Date(this.loopForm.end.utc);
      if (startDate > endDate) {
        this.fullscreenloading = false;
        const msg = "Start-Time is later than End-Time in Loop event time";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.start.timezone === "" || this.loopForm.end.timezone === "") {
        this.fullscreenloading = false;
        const msg = "Timezone is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.loopForm.welcomeBox.coachHtmlTips === "") {
        this.fullscreenloading = false;
        const msg = "Loop's Welcome Message is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      var programLength = typeof this.loopForm.programs === "undefined" ? 0 : this.loopForm.programs.length;
      if (programLength > 0) {
        let programs = this.loopForm.programs.filter(p => p.type !== "hike");
        for (let stageIndex in programs) {
          if (programs[stageIndex].type === "") {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Program's type is missing in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          if (programs[stageIndex].title === "") {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Program's title is missing in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          if (programs[stageIndex].title.length > 50) {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Program's title max length is 50 in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          if (programs[stageIndex].icon === "") {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Program's Icon is missing in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          if (programs[stageIndex].icon !== "none" && programs[stageIndex].iconColor === "") {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Program's Icon Color is missing in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          if (programs[stageIndex].classTime.length > 100) {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Program's class time max length is 100 in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          if (typeof programs[stageIndex].shortDescription !== 'undefined' && programs[stageIndex].shortDescription.length > PROGRAM_DESCRIPTION_MAX_LENGTH) {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Program's description max length is " + PROGRAM_DESCRIPTION_MAX_LENGTH + " in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          if (programs[stageIndex].start.utc === "" || programs[stageIndex].end.utc === "") {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Program's Event time is missing in Program " + (1 * stageIndex + 1), "error");
            return;
          }
          const startDate = new Date(programs[stageIndex].start.utc);
          const endDate = new Date(programs[stageIndex].end.utc);
          if (startDate > endDate) {
            this.fullscreenloading = false;
            const msg = `Start-Time is later than End-Time in Program ` + (1 * stageIndex + 1) + " event time";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          const nextIndex = 1 * stageIndex + 1;
          const nextProgram = programs[nextIndex];
          // console.info(nextProgram);
          // console.info("new program:" + nextIndex);
          // console.info("program" + stageIndex);
          if (nextProgram != undefined && nextProgram !== null) {
            console.info("nextStartDate:" + nextProgram.start.utc);
            console.info("startDate:" + startDate);
            const nextStartDate = new Date(nextProgram.start.utc);
            if (startDate > nextStartDate) {
              this.fullscreenloading = false;
              const msg = `The Start-Time of Program ` + (1 * stageIndex + 1) + " is later than that of Program " + (1 * nextIndex + 1);
              (0, _log.displayPopupMessage)(msg, "error");
              return;
            }
          }
          //The start time of Program1 is longer than that of Program2
          if (programs[stageIndex].type === "info") {
            console.info("program type:" + stageIndex + programs[stageIndex].type);
            console.info("program action text:" + stageIndex + programs[stageIndex].action.text);
            if (this.selectShowButton[stageIndex] === "Y") {
              if (programs[stageIndex].action.text === "") {
                this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("Program's Call to Action Button Text is missing in Program " + (1 * stageIndex + 1), "error");
                return;
              }
              if (programs[stageIndex].action.message === "") {
                this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("Program's Call to Action Popup Message is missing in Program " + (1 * stageIndex + 1), "error");
                return;
              }
            }
            if (programs[stageIndex].action.message.length > POPUP_MESSAGE_MAX_LENGTH + INPUT_BOX_LENGTH_BUFFER) {
              this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Popup Message max length is " + POPUP_MESSAGE_MAX_LENGTH + " in Program " + (1 * stageIndex + 1), "error");
              return;
            }
          }
          if (programs[stageIndex].type === "externalAction") {
            console.info("program type:" + stageIndex + programs[stageIndex].type);
            console.info("program action text:" + stageIndex + programs[stageIndex].action.text);
            if (programs[stageIndex].action.text === "") {
              this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Button Text is missing in Program " + (1 * stageIndex + 1), "error");
              return;
            }
            if (programs[stageIndex].action.url === "") {
              this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action URL is missing in Program " + (1 * stageIndex + 1), "error");
              return;
            }
            if (programs[stageIndex].action.message.length > POPUP_MESSAGE_MAX_LENGTH + INPUT_BOX_LENGTH_BUFFER) {
              this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Popup Message max length is " + POPUP_MESSAGE_MAX_LENGTH + " in Program " + (1 * stageIndex + 1), "error");
              return;
            }
          }
          if (programs[stageIndex].type === "enrollment") {
            console.info("program type:" + stageIndex + programs[stageIndex].type);
            console.info("program action text:" + stageIndex + programs[stageIndex].action.text);
            if (programs[stageIndex].action.text === "") {
              this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Button Text is missing in Program " + (1 * stageIndex + 1), "error");
              return;
            }
            const options = programs[stageIndex].options;
            if (options.length === 0) {
              console.info("program options length:" + stageIndex + options.length);
              this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's must have at least 1 hike selected in Program " + (1 * stageIndex + 1), "error");
              return;
            }
            for (let optionIndex in options) {
              if (options[optionIndex].objectId === "") {
                this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("Please select a Hike from Option" + (1 * optionIndex + 1) + ' in Program' + (1 * stageIndex + 1), "error");
                return;
              }
            }
          }
        }
      }

      // submit
      (0, _log.showDebugLog)("Save Form", this.loopForm);
      const data = _lodash.default.cloneDeep(this.loopForm);

      // LHVO-4155 Do not pass resource if it is empty
      if (data.welcomeBox.resource === "") {
        delete data.welcomeBox.resource;
      }
      data.programs.forEach((program, index) => {
        if (program.options.length > 0) {
          program.options.forEach((item, index) => {
            if (item.objectId === "" || item.objectId === undefined || item.objectId === null) {
              program.options.splice(index, 1);
            }
          });
        }
      });
      console.info(data);
      (0, _loop.updateLoopById)(token, id, data).then(response => {
        (0, _log.showDebugLog)("Loop-update-response", response);
        this.fullscreenloading = false;
        this.loopForm.id = response.data.id;
        this.loopForm.publish = response.data.publish;
        this.loopForm.staff = this.loopForm.staff;
        this.loopForm.updatedAt = response.data.updatedAt;
        const clientPocList = this.loopForm.staff.filter(row => row.role === 'client-poc');
        this.oldClientPocList = _lodash.default.cloneDeep(clientPocList);
        const msg = `${response.data.title} (${response.data.id}) is updated.`;
        (0, _log.displayPopupMessage)(msg, "success");
        if (this.$refs.loopStaff) {
          this.$refs.loopStaff.getStaffList();
        }
        (0, _ga.writeGaEvent)(this, "Loop", `${_lifehikesInitData.userEvent.loop.edit}`, oEmail, `Edit in Loop Main - Loop Id: ${this.loopForm.id}`);
        (0, _ga.writeGaEvent)(this, "Loop", `${_lifehikesInitData.userEvent.loop.edit}`, this.email, `avoid undefined email, Edit in Loop Main - Loop Id: ${this.loopForm.id}`);
        var keys_to_keep = ["role", "user"];
        const result = this.loopForm.staff.map(e => {
          const obj = {};
          keys_to_keep.forEach(k => obj[k] = e[k]);
          return obj;
        });
        (0, _ga.writeGaEvent)(this, "Loop", `${_lifehikesInitData.userEvent.loop.edit}`, oEmail, `Staff: ${JSON.stringify(result)}`);
      }).catch(error => {
        (0, _log.showDebugLog)("Loop-update-error", error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    getLoop(id, isCopy) {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      this.fullscreenloading = true;
      (0, _loop.getLoopById)(token, id).then(response => {
        const d = response.data;
        // check error and return immediate
        if (typeof d.id === "undefined") {
          this.fullscreenloading = false;
          const msg = "Cannot get the loop, please contact to system administrator";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        const loop = _lodash.default.cloneDeep(d); //JSON.parse(JSON.stringify(d));
        loop.programs.forEach(function (program) {
          if (program.type === "enrollment") {
            const ops = program.options.filter((ele, index, arr) => {
              return arr.indexOf(ele) === 0;
            });
            program.options = ops;
          }
        });
        (0, _log.showDebugLog)("Loop-getLoopById-response", d);
        (0, _log.showDebugLog)("Loop-getLoopById-response1", loop);
        this.loopForm = loop;
        if (isCopy) {
          //GenneralInfo
          if (this.$route.query.gi !== "true") {
            this.loopForm.type = "";
            this.loopForm.title = "";
            this.loopForm.internal.title = "";
            this.loopForm.description = "";
          }
          //Salesforce
          if (this.$route.query.sf !== "true") {
            this.loopForm.internal.opportunityNumber = "";
            this.loopForm.internal.clientName = "";
          }
          //EventTime
          if (this.$route.query.et !== "true") {
            this.loopForm.start = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
            this.loopForm.end = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          }
          //Welcome Resource Setting
          if (this.$route.query.wrs !== "true") {
            this.loopForm.welcomeBox = {
              coachHtmlTips: "",
              resource: "",
              resourceTitle: ""
            };
          }
          //Programs
          if (this.$route.query.p !== "true") {
            this.loopForm.programs = [];
          }
          //Staff
          if (this.$route.query.s !== "true") {
            this.loopForm.staff = [];
          }
          //Email Settings
          if (this.$route.query.es !== "true" && d.automatedEmail) {
            this.loopForm.automatedEmail = [];
          } else {
            this.loopForm.automatedEmail = d.automatedEmail;
          }
        } else {
          const clientPocList = this.loopForm.staff.filter(row => row.role === 'client-poc');
          console.info(clientPocList);
          this.oldClientPocList = _lodash.default.cloneDeep(clientPocList);
        }
        // metadata
        if (isCopy) {
          this.loopForm.metadata = {
            tenant: ""
          };
        } else {
          this.loopForm.metadata = typeof d.metadata === "undefined" ? {
            tenant: ""
          } : d.metadata;
        }

        //  createdAt and updatedAt
        if (isCopy) {
          this.loopForm.createdAt = "";
          this.loopForm.updatedAt = "";
        }
        // To Solve internal title lagging issue, use other variable name to replace.
        this.fullscreenloading = false;
      }).catch(error => {
        (0, _log.showDebugLog)("loop-getLoopById-error", error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, "error");
      }).finally(() => {
        if (isCopy) {
          this.loopForm.id = "copy";
          this.loopForm.publish = "";
        }
      });
    },
    handleClick() {
      // do something later
      // auto save when change tab
    },
    updateParentStaff(staff) {
      this.loopForm.staff = staff;
      (0, _log.showDebugLog)("Update loopForm-staff", this.loopForm);
    },
    updateParentGenInfo(info) {
      //showDebugLog("Update loopForm", info);
      //showDebugLog("Update loopForm 1",  this.loopForm);
    },
    updateParentProgram(res) {
      (0, _log.showDebugLog)("Parent loop-Program", res);
      this.loopForm.programs = res;
      //console.info(this.loopForm)
    },
    checkArrayLength(obj) {
      if (Array.isArray(obj)) {
        return obj.length;
      } else {
        return 0;
      }
    },
    checkMandateFields() {
      // LHVO-5043 - remove validation of Producer
      // console.log("form", this.loopForm.staff)
      // var manager = _.find(this.loopForm.staff, function(s) {
      //   return s.role === "manager";
      // });
      var contact = _lodash.default.find(this.loopForm.staff, function (s) {
        return s.role === "contact";
      });
      // console.log("producer", producer)
      // console.log("string length", _.trim(this.loopForm.internal.opportunityNumber).length)
      if (
      // typeof manager === "undefined" ||
      typeof contact === "undefined" || _lodash.default.trim(this.loopForm.internal.opportunityNumber).length == 0) {
        return true;
      } else {
        return false;
      }
    },
    updateSelectShowButton(selectShowButton) {
      (0, _log.showDebugLog)("Parent selectShowButton", selectShowButton);
      this.selectShowButton = selectShowButton;
    },
    updateParentEmailRuleSet(info) {
      this.loopForm.automatedEmail = info;
    }
  }
};